var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('router-view',{attrs:{"name":"default"}}),_c('router-view',{attrs:{"name":"footer"}}),_c('cookies-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }